<template>
	<div>
		<notifications />
        <preloader v-if="isLoading" />
		<template-form v-if="isReady"
			title="Add Invoice"
			submitTxt="Save Invoice"
			:fields="fields"
			:errors="fieldErrors"
			:masterService="masterService"
			:defaultPaymentTerm="defaultPaymentTerm"
			:totalPercent="totalPercent"
			:createMilestone="createMilestone"
			:removeMilestone="removeMilestone"
			:isLoading="isLoading"
			:onSubmit="handleSubmit"
			:basePrice="basePrice" />
	</div>
</template>

<script>
import Form from './Form.vue';
import { defaultFields, getBasePrice, defaultErrors } from "./helpers";
import { displayDate, incrementTailingNumber } from "../../helpers";
import Preloader from "../Preloader.vue";

export default {
	components: {
		'template-form': Form, Preloader
	},
	data() {
		return {
			basePrice: 0,
			defaultPaymentTerm: [],
			defaultTerm: "",
			fields: defaultFields(),
			fieldErrors: defaultFields(),
			isLoading: false,
			isReady: false,
			masterService: [],
		}
	},
	async beforeMount() {
        this.isLoading = true;
        this.fields.customer = "";
		try {
			let response = await axios.get('/services');
			this.masterService = response.data.data;
			
			const settingResponse = await axios.get('settings');
			let { payment_terms_template } = settingResponse.data.data.settings;
			this.defaultPaymentTerm = payment_terms_template === null ? [] : payment_terms_template;
			this.fields.terms = settingResponse.data.data.settings.proposal_terms_template;

			if (typeof this.$route.query.proposal_id !== "undefined") {
				const proposalResponse = await axios.get(`/proposals/` + this.$route.query.proposal_id);
				this.fields = this.parseData(proposalResponse.data.data);
				this.fields.frequency = this.fields.frequency ? this.fields.frequency: '0';
				this.defaultPaymentTerm = JSON.parse(this.fields.payment_terms);
				this.defaultTerm = this.fields.terms;
			}

			if (typeof this.$route.query.duplicate_id !== "undefined") {
				const invoiceResponse = await axios.get(`/invoices/` + this.$route.query.duplicate_id);
				this.fields = this.parseData(invoiceResponse.data.data);
				this.fields.frequency = this.fields.frequency ? this.fields.frequency: '0';
				this.defaultPaymentTerm = this.fields.payment_terms === null ? [] : JSON.parse(this.fields.payment_terms);
				this.defaultTerm = this.fields.terms;
			}

			response = await axios.get('/invoices/last-number');
			this.fields.number = response.data.data ? 
				incrementTailingNumber(response.data.data) :
				this.fields.number;
		} catch {
			this.$notify({
				type: 'error',
				title: 'Oops!',
				text: 'Sorry, an error occured!'
			})
        } finally {
			this.isLoading = false
			this.isReady = true
		}
	},
	computed: {
		totalPercent() {
			let items = this.defaultPaymentTerm;
			let currentPercentage = items.reduce((subtotal, item) => {
				return parseFloat(subtotal) + parseFloat(item.percentage);
			}, 0);
			return currentPercentage - 100;
		}
	},
	methods: {
		async handleSubmit(fields) {
			this.fieldErrors = defaultErrors();
			this.isLoading = true;

			if (!this.validateInputs()) {
				this.isLoading = false;
				return;
			}

			try {
				var data = {
					...fields,
					customer_id: fields.customer.id,
					payment_terms: JSON.stringify(this.defaultPaymentTerm),
				}

				const response = await axios.post('/invoices', data);
				const resource = response.data.data

				this.fields = {
					...defaultFields(),
					price: this.basePrice,
				};

				const responseNumber = await axios.get('/invoices/last-number');
				this.fields.number = responseNumber.data.data ? 
					incrementTailingNumber(responseNumber.data.data) :
					this.fields.number;
				
				this.$notify({
					type: 'success',
					title: 'Success',
					text: `${resource.number} created!`
				})
				this.$router.push(`/invoices/${resource.id}/view`)
			} catch {
				this.$notify({
					type: 'error',
					title: 'Oops!',
					text: 'Sorry, an error occured!'
				})
			}

			this.isLoading = false;
		},
		parseData(item) {
			return {
				id: item.id,
				title: item.title,
				customer: {
					...item.customer,
					label: item.customer.name,
				},
				title: item.title,
				number: "",
				date: displayDate(item.date),
				due_date: displayDate(item.due_date),
				discount: item.discount,
				items: item.details,
				payment_terms: item.payment_terms,
				note: item.note,
				terms: item.terms ? item.terms : "",
				type: item.type ? item.type : "not_recurring"
			}
		},
		validateInputs() {
			if (this.totalPercent != 0) {
				this.fieldErrors.payment_term = 'Invalid total payment percentage.';
				return false;
			}

			return true;
		},
		createMilestone() {
			this.defaultPaymentTerm.push({description: null, percentage: 0});
		},
		removeMilestone(targetIndex) {
			let items = this.defaultPaymentTerm;
			this.defaultPaymentTerm = items.filter((item, index) => {
				return index != targetIndex;
			});
		},
	}
}
</script>
